import { render, staticRenderFns } from "./LmTableCustom.vue?vue&type=template&id=a9f966b0&scoped=true"
import script from "./LmTableCustom.vue?vue&type=script&lang=js"
export * from "./LmTableCustom.vue?vue&type=script&lang=js"
import style0 from "./LmTableCustom.vue?vue&type=style&index=0&id=a9f966b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f966b0",
  null
  
)

export default component.exports